'use client';

import { useTranslations } from 'next-intl';
import { cn, formatCount } from '@/app/utils';
import type { StatConfig, ViduV1UserStat } from '../types';

interface StatDisplayProps {
  statConfigs: StatConfig[];
  statData?: ViduV1UserStat;
  isMe: boolean;
}

export const StatDisplay = ({ statConfigs, statData, isMe }: StatDisplayProps) => {
  const t = useTranslations();

  if (!statConfigs.length || !statData) return null;

  return (
    <div className="flex items-center sm:mt-3">
      {statConfigs.map((config, index) => {
        const value = statData[config.key] ?? 0;
        return (
          <div
            key={config.key}
            className="flex items-center sm:flex-1 sm:justify-center"
            onClick={(e) => {
              if (config.onClick && isMe) {
                e.stopPropagation();
                config.onClick();
              }
            }}
          >
            <div
              className={cn(
                'group flex items-center gap-1 px-3 sm:flex-col-reverse sm:gap-0 sm:px-0',
                index === 0 && 'pl-0',
              )}
            >
              <div className="text-sm text-system-white/70">{t(config.langKey)}</div>
              <div
                className={cn(
                  'min-w-[1ch] text-white',
                  config.onClick && isMe && 'group-hover:underline group-hover:underline-offset-auto',
                )}
              >
                {formatCount(+(value ?? 0))}
              </div>
            </div>
            {index < statConfigs.length - 1 && <div className="h-4 w-px rounded-full bg-system-white/20 sm:hidden" />}
          </div>
        );
      })}
    </div>
  );
};
